//@flow
import React from 'react'
import type { Filter } from '../types'

type Props = {
  className: string,
  filters: Array<Filter>,
  toggleFilter: Function,
  onCancel: Function,
  onFilter: Function,
}

const FilterBox = ({
  filters,
  toggleFilter,
  onCancel,
  onFilter,
  className = '',
}: Props) => {
  if (!filters) {
    return null
  }

  const renderFilterOption = (filter: Filter) => {
    return (
      <div
        key={filter.label}
        className="flex justify-between items-center mb2"
        style={{ width: '140px' }}
      >
        <div className="mr2">{filter.label}</div>
        <input
          className="flex-no-shrink"
          type="checkbox"
          checked={filter.active}
          onClick={() => toggleFilter(filter)}
        />
      </div>
    )
  }

  return (
    <div className={`${className} bg-white gray shadow-2 nowrap`}>
      <div className="pa2">
        {filters.map(filter => renderFilterOption(filter))}
      </div>
      <div className="flex w-100 bt b--moon-gray tc ">
        <div className="w-50 pa2 br b--moon-gray pointer" onClick={onCancel}>
          Cancel
        </div>
        <div className="w-50 pa2 pointer" onClick={onFilter}>
          Filter
        </div>
      </div>
    </div>
  )
}

export default FilterBox



// WEBPACK FOOTER //
// ./src/components/FilterBox.js